import React, { useState, useContext, useEffect } from "react";
import Layout from "pages/shared/Layout";

import { StoreContext } from "shared/context/store-context";
import { ownerShipTypes, yesNoUnknowTypes, plateTypes, criminalRecordTypes, graduationTypes } from "shared/util/types";
import { formatDate } from "shared/util/time";
import { PERMISSION_TYPES } from "shared/util/constants";
import { AuthContext } from "shared/context/auth-context";

import InventoryDriverItem from "./InventoryDriverItem";

const InventoryDrivers = () => {
  const auth = useContext(AuthContext);
  const itemType = "driverdetail";
  const listName = "inventory_drivers";

  const {
    driverDetails,
    drivers,
    DeleteDriverDetail,
    UpdateDriverDetail,
    InsertDriverDetail,
    driverOptions,
    vehicles,
  } = useContext(StoreContext);

  const [pageItems, setPageItems] = useState();

  const shouldHighlightDate = (date) => {
    if (!date) {
      return true;
    }
    const currentDate = new Date();
    const oneMonthAfter = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    return date <= formatDate(oneMonthAfter).split(" ")[0];
  };

  useEffect(() => {
    setPageItems(driverDetails);
  }, [driverDetails]);

  const listColumns = [
    {
      field: "driver",
      headerName: "İsim",
      width: 300,
      valueGetter: (params) => drivers.find((user) => user?._id === params?.row?.driver)?.name || "",
    },
    {
      field: "phonenumber",
      headerName: "Telefon",
      width: 150,
      valueGetter: (params) => drivers.find((user) => user?._id === params?.row?.driver)?.phonenumber || "",
    },
    {
      field: "vehicle",
      headerName: "Mevcut Araç",
      width: 150,
      valueGetter: (params) => vehicles.find((vehicle) => vehicle.driver === params?.row?.driver)?.plate || "-",
    },

    {
      field: "isActive",
      headerName: "Aktif",
      width: 100,
      valueGetter: (params) => (params?.row?.isActive ? "Evet" : "Hayır"),
    },
    {
      field: "identity",
      headerName: "Kimlik No",
      width: 150,
    },
    { field: "iban", headerName: "IBAN", width: 200 },

    { field: "birthDate", headerName: "Doğum Tarihi", width: 150 },
    { field: "license", headerName: "Ehliyet Tipi", width: 100 },

    { field: "address", headerName: "Adres", width: 200 },

    { field: "secondContactName", headerName: "İkinci İletişim İsmi", width: 150 },
    { field: "secondContactPhone", headerName: "İkinci İletişim Telefonu", width: 150 },
    { field: "secondContactRelation", headerName: "İkinci İletişim Yakınlığı", width: 150 },

    { field: "companySgkRegistration", headerName: "Şirket SGK", width: 200 },
    { field: "supplierSgkRegistration", headerName: "Tedarikçi SGK", width: 200 },
    {
      field: "criminalRecord",
      headerName: "Sabıka",
      width: 100,
      valueGetter: (params) =>
        criminalRecordTypes.find((type) => type.value === params?.row?.criminalRecord)?.label || "",
    },
    { field: "criminalRecordDate", headerName: "Sabıka Tarihi", width: 150 },
    { field: "identityExpirationDate", headerName: "Nüfus Cüzdanı", width: 150 },
    { field: "srcCertificate", headerName: "SRC", width: 100 },
    { field: "srcCertificateStartDate", headerName: "SRC Başlangıç", width: 150 },
    { field: "licenseInquiry", headerName: "Ehliyet Numarası", width: 150 },
    { field: "licenseInquiryDate", headerName: "Ehliyet Sorgu Tarihi", width: 150 },
    {
      field: "graduation",
      headerName: "Eğitim",
      width: 150,
      valueGetter: (params) => graduationTypes.find((type) => type.value === params?.row?.graduation)?.label || "-",
    },
    {
      field: "psychotechnicEndDate",
      headerName: "Psikoteknik Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.psychotechnicEndDate) ? "highlight-red" : undefined),
    },
    {
      field: "licenseExpirationDate",
      headerName: "Ehliyet Bitiş",
      width: 150,
      cellClassName: (params) =>
        shouldHighlightDate(params?.row?.licenseExpirationDate) ? "highlight-red" : undefined,
    },

    {
      field: "licensePhoto",
      headerName: "Ehliyet Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.licensePhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.licensePhoto ? undefined : "highlight-red"),
    },
    {
      field: "identityPhoto",
      headerName: "Kimlik Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.identityPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.identityPhoto ? undefined : "highlight-red"),
    },
    {
      field: "criminalRecordPhoto",
      headerName: "Sabıka Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.criminalRecordPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.criminalRecordPhoto ? undefined : "highlight-red"),
    },
    {
      field: "srcCertificatePhoto",
      headerName: "SRC Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.srcCertificatePhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.srcCertificatePhoto ? undefined : "highlight-red"),
    },
    {
      field: "psychotechnicPhoto",
      headerName: "Psikoteknik Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.psychotechnicPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.psychotechnicPhoto ? undefined : "highlight-red"),
    },
    // {
    //   field: "iskurEmploymentRegistryPhoto",
    //   headerName: "İşkur Foto",
    //   width: 150,
    //   valueGetter: (params) => (params?.row?.iskurEmploymentRegistryPhoto ? "Evet" : "Hayır"),
    //   cellClassName: (params) => (params?.row?.iskurEmploymentRegistryPhoto ? undefined : "highlight-red"),
    // },
    // {
    //   field: "identityRegistryPhoto",
    //   headerName: "Kimlik Kayıt Foto",
    //   width: 150,
    //   valueGetter: (params) => (params?.row?.identityRegistryPhoto ? "Evet" : "Hayır"),
    //   cellClassName: (params) => (params?.row?.identityRegistryPhoto ? undefined : "highlight-red"),
    // },
    {
      field: "photo",
      headerName: "Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.photo ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.photo ? undefined : "highlight-red"),
    },
    // {
    //   field: "militaryStatusPhoto",
    //   headerName: "Askerlik Foto",
    //   width: 150,
    //   valueGetter: (params) => (params?.row?.militaryStatusPhoto ? "Evet" : "Hayır"),
    //   cellClassName: (params) => (params?.row?.militaryStatusPhoto ? undefined : "highlight-red"),
    // },
    {
      field: "healthReportPhoto",
      headerName: "Sağlık Rapor Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.healthReportPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.healthReportPhoto ? undefined : "highlight-red"),
    },
    {
      field: "graduationCertificatePhoto",
      headerName: "Mezuniyet Foto",
      width: 150,
      valueGetter: (params) => (params?.row?.graduationCertificatePhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.graduationCertificatePhoto ? undefined : "highlight-red"),
    },
    { field: "notes", headerName: "Notlar", width: 200 },
  ];

  const standardHelpItems = [
    "1. Şu anda erişim yetkinizin olduğu Sürücü Bilgileri ekranını görüntülemektesiniz.",
    "2. Filtreleri kullanarak ilgili sürücü bilgilerine daha kolay erişim sağlayabilirsiniz.",
    "3. Sütun isimlerine tıklayarak sıralamayı değiştirebilirsiniz.",
    "4. Yeni sürücü bilgisi eklemek için 'Yeni Sürücü Bilgileri Yarat' butonuna tıklayın.",
  ];

  const highlightedHelpItems = [
    "1. Bu sayfa sistemde tanımlı bir sürücünün bilgilerinin yönetilmesi için tasarlanmıştır. Sürücünün daha önce sistemde tanımlı olması gerekmektedir.",
    "2. Bir sürücünün sistemde tanımlanması için yukarıdaki SÜRÜCÜLER sekmesini kullanınız. Böylece sürücü SERVİSTESİN sistemine dahil edilmiş olacaktır.",
    "3. Ardından tekrar bu sekmeye gelerek SERVİSTESİN sistemine dahil edilen sürücünün bilgilerini 'Yeni Sürücü Bilgileri' yarat tuşuna basarak girebilirsiniz.",
    "4 Kimlik numarası girmediğiniz sürücünün dosya işlemlerini gerçekleştiremezsiniz.",
    "5. Kimlik bilgisi olduğu halde 'Dosyalara Git' tuşunu göremiyorsanız, alttaki Güncelle tuşuna bir kez basınız.",
    "6. Sürücünün kullandığı aracı bu ekranda değiştiremezsiniz. Araç değişikliği için yandaki ARAÇLAR sekmesini kullanınız.",
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      showSelectedYear={false}
      isAlwaysFullScreen={true}
      hideCreateNewItem={!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WRITE_INVENTORY]}
      hideRightHeader={false}
      SelectedItemComponent={InventoryDriverItem}
      NewItemComponent={InventoryDriverItem}
      DeleteItem={DeleteDriverDetail}
      InsertItem={InsertDriverDetail}
      UpdateItem={UpdateDriverDetail}
      standardHelpItems={standardHelpItems}
      highlightedHelpItems={highlightedHelpItems}
    />
  );
};

export default InventoryDrivers;
